import { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { useCurrencyOptions } from '../hooks/useCurrencyOptions';
import { useSetUserBoardSettings, useUserBoardSettings } from '../userBoardSettings/hooks/useUserBoardSettings';
import { DEFAULT_CARD_PREFERENCES } from '../../constants';
import { jsx as _jsx } from "react/jsx-runtime";
const EditBoardSettingsPanelContext = /*#__PURE__*/createContext(undefined);
export function EditBoardSettingsPanelProvider({
  children,
  objectTypeId
}) {
  //get initial settings

  const {
    data: initialSettings,
    loading
  } = useUserBoardSettings(objectTypeId);
  const [draft, setDraft] = useState(null);
  const settings = useMemo(() => {
    if (initialSettings) {
      return Object.assign({}, initialSettings, draft || {});
    } else {
      return DEFAULT_CARD_PREFERENCES;
    }
  }, [draft, initialSettings]);
  const updateDraft = useCallback(update => {
    setDraft(Object.assign({}, settings, update));
  }, [setDraft, settings]);
  const resetDraft = useCallback(() => {
    setDraft(null);
  }, [setDraft]);
  const saveDraft = useSetUserBoardSettings(objectTypeId);

  // get currency values

  const currencyOptions = useCurrencyOptions(objectTypeId, settings);
  const value = {
    settings,
    currencyOptions,
    saveDraft,
    updateDraft,
    resetDraft,
    objectTypeId,
    loading
  };
  return /*#__PURE__*/_jsx(EditBoardSettingsPanelContext.Provider, {
    value: value,
    children: children
  });
}
export function useEditBoardSettingsPanelContext() {
  const context = useContext(EditBoardSettingsPanelContext);
  if (!context) {
    throw new Error('useEditBoardSettingsPanelContext must be within EditBoardSettingsPanelProvider');
  }
  return context;
}
export function useGetEditBoardSettingsPanelContext() {
  const context = useContext(EditBoardSettingsPanelContext);
  return useCallback(() => {
    if (!context) {
      throw new Error('useEditBoardSettingsPanelContext must be within EditBoardSettingsPanelProvider');
    }
    return context;
  }, [context]);
}